import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Badge,
  Input,
  Spinner
} from "reactstrap";
import { useHistory, useLocation } from "react-router-dom";
import UiContent from "../../Components/Common/UiContent";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import { useSelector } from "react-redux";
import RecordDescriptionModal from "./RecordDescriptionModal";
import UploadDescriptionModal from "./UploadDescriptionModal";
import { postDataAPI } from "../../helpers/phpbackend_helper";
import DishPairingModal from "./DishPairingModal";

const CreateFlashCard = () => {
    const history = useHistory();
    const location = useLocation();

    const [currency, setCurrency] = useState('$');
    const { currentOutlet } = useSelector((state) => ({
            currentOutlet: state.UserOutletGroup.currentOutlet
    }));
    useEffect(() => {
        if (currentOutlet?.currency !== "") {
        setCurrency(currentOutlet?.currency);
        }
    }, [currentOutlet]);

  // you can pass dish data via route state
  const dish = location.state?.dish || {
    item_name: "",
    Course: "",
    price: "",
    currency: "",
    item_description: ""
  };
  const badgeColor = location.state?.badgeColor || "#405189";

    const [started, setStarted] = useState(false);
    const [showRecordModal, setShowRecordModal] = useState(false);
    const [coachingScript, setCoachingScript] = useState(dish.item_description);
    const [showUploadModal, setShowUploadModal] = useState(false);
    const [enhancing, setEnhancing] = useState(false);
    const [loading, setLoading] = useState(false);
    const [showPairingModal, setShowPairingModal] = useState(false);
    const [pairings, setPairings] = useState([]); // [{name, price}]


    const enhanceText = async () => {
      if (!coachingScript.trim()) {
        alert("Please add coaching script first");
        return;
      }

      try {
        setEnhancing(true);

        const res = await postDataAPI({
          serviceName: "server_data",
          op: "enhance-text-oi",
          content: coachingScript,
          dishName: dish?.item_name,
          category: dish?.course_name
        });

        if (res.status === "ok") {
          setCoachingScript(res.data.enhancedDescription || "");
        }
      } catch (err) {
        alert("Text enhancement failed");
      } finally {
        setEnhancing(false);
      }
    };


    const createFlashCard = async () => {
      if (!coachingScript.trim()) {
        alert("Please add coaching script first");
        return;
      }

      try {
        setLoading(true);

        const res = await postDataAPI({
          serviceName: "item_data",
          op: "create_update_flash_card",
          coching_script: coachingScript,
          item_id: dish?.item_id,
          to_item_id: pairings
        });

        if (res.status === "ok") {
          history.push("/flash-cards");
        }
      } catch (err) {
        alert("Flash card creation failed");
      } finally {
        setLoading(false);
      }
    };



  return (
    <React.Fragment>
      <UiContent />
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title="Menu Management" pageTitle="Dashboard &nbsp; > &nbsp; Server Performance Coaching" />

          {/* STEP 1 : READY TO TRAIN */}
          {!started && (
            <Card className="border-0 shadow-sm">
              <CardBody
                className="p-4"
                style={{
                  background:
                    "linear-gradient(135deg, #eef6fb, #f9fcff)",
                  borderRadius: 12
                }}
              >
                <Button outline  className="mb-3"
                    onClick={() => history.push("/menu-management")}
                >
                    ⬅ Back
                </Button>
                <h4 className="fw-bold mb-3">Ready to Train?</h4>
                <p className="text-muted mb-4">
                  This AI-powered training session will help you master the
                  perfect pitch for <b>{dish.item_name}</b>.
                </p>

                <Button
                  color="primary"
                  size="lg"
                  className="px-5 w-100"
                  onClick={() => setStarted(true)}
                >
                  <i className="ri-play-fill me-2"></i>
                  Start Training Session
                </Button>
              </CardBody>
            </Card>
          )}

          {/* STEP 2 : FLASH CARD FORM */}
          {started && (
            <Card className="border-0 shadow-sm">
              <CardBody
                className="p-4"
                style={{
                  background:
                    "linear-gradient(135deg, #eef6fb, #f9fcff)",
                  borderRadius: 12
                }}
              >
                {/* Header */}
                <div className="mb-3">
                    <Button outline  className="mb-3"
                        onClick={() => history.push("/menu-management")}
                    >
                        ⬅ Back
                    </Button>
                  <h4 className="fw-bold mb-1">{dish.item_name}</h4>
                  <div className="d-flex align-items-center gap-2">
                    <Badge pill
                      className="badge-course"
                      style={{ "--badge-color": badgeColor }}
                    >
                      {dish.course_name}
                    </Badge>
                    <span className="fw-medium">
                      {currency} {dish.price}
                    </span>
                  </div>
                </div>

                {/* Sales Description */}
                <div className="mb-4">
                  <label className="fw-medium mb-1">
                    <i className="ri-file-text-line me-1"></i>
                    Sales Description
                  </label>
                  <div className="p-3 bg-light rounded text-muted">
                    {dish.item_description}
                  </div>
                </div>

                {/* Coaching Script */}
                <div className="mb-4">
                  <div className="d-flex align-items-center gap-2 mb-2">
                    <i className="ri-mic-line text-warning"></i>
                    <span className="fw-medium">Coaching Script</span>
                    <Badge color="warning" pill>
                      Used for AI Video Generation
                    </Badge>

                    <div className="ms-auto d-flex gap-2">
                        <Button size="sm" outline onClick={() => setShowRecordModal(true)}>
                            <i className="ri-mic-line me-1" /> Record
                        </Button>

                      <Button size="sm" outline onClick={() => setShowUploadModal(true)}>
                        <i className="ri-upload-2-line me-1"></i> Upload
                      </Button>
                      
                      <Button
                          outline
                          size="sm"
                          onClick={enhanceText}
                          disabled={enhancing}
                        >
                          {enhancing ? (
                            <>
                              Enhancing...
                            </>
                          ) : (
                            <>
                              ✨ Enhance with AI
                            </>
                          )}
                        </Button>

                    </div>
                  </div>

                  <Input
                    type="textarea"
                    rows="5"
                    value={coachingScript}
                    onChange={(e) => setCoachingScript(e.target.value)}
                    placeholder="Coaching script will appear here..."
                    />

                </div>

                {/* Drinks Pairing */}
                <div className="mb-4">
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <span className="fw-medium">
                      🍹
                      Dish Pairing
                    </span>
                    <Button
                      size="sm"
                      outline
                      color="primary"
                      onClick={() => setShowPairingModal(true)}
                    >
                      🍹 Add Dish Pairing
                    </Button>

                  </div>

                  <div className="p-3 bg-light rounded">
                    <small className="text-muted">Selected Pairings:</small>
                    <div className="mt-2 d-flex gap-2 flex-wrap">
                      {pairings.length === 0 ? (
                        <small className="text-muted">
                          No drinks paired yet. Add drinks to include in the Perfect Pairing section of the flashcard.
                        </small>
                      ) : (
                        pairings.map((p, i) => (
                          <Badge key={i} color="info" pill>
                            {p.item_name}
                          </Badge>
                        ))
                      )}
                    </div>
                  </div>
                </div>

                {/* Footer Action */}
                <Button
                  color="primary"
                  block
                  onClick={createFlashCard}
                  disabled={loading}
                >
                  ✔ Create Flash Cards
                </Button>
              </CardBody>
            </Card>
          )}

          <RecordDescriptionModal
            isOpen={showRecordModal}
            dishName={dish?.item_name}
            onClose={() => setShowRecordModal(false)}
            onSave={(text) => {
                setCoachingScript(text);
                setShowRecordModal(false);
            }}
          />
          <UploadDescriptionModal
            isOpen={showUploadModal}
            dish={dish}
            onClose={() => setShowUploadModal(false)}
            onSave={(text) => {
              setCoachingScript(text);
              setShowUploadModal(false);
            }}
          />

          <DishPairingModal
            isOpen={showPairingModal}
            toggle={() => setShowPairingModal(false)}
            onSave={(data) => setPairings(data)}
            selectedPairings={pairings}
          />


        </Container>
      </div>
    </React.Fragment>
  );
};

export default CreateFlashCard;
